(function () {
  if (window.__peOfferPopupInit) return;
  window.__peOfferPopupInit = true;

  const offerMoney = new Intl.NumberFormat('de-DE', {style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'});
  const OFFERS = JSON.parse(document.getElementById('MnzeOfferProducts')?.textContent || '[]').map(offer => ({...offer, price: offerMoney.format(offer.price / 100), compareAtPrice: offer.compareAtPrice ? offerMoney.format(offer.compareAtPrice / 100) : ''}));

  const EXCLUDED_PRODUCT_IDS = new Set(["10484524679434", "10521504153866", "10480056205578", "10484525072650", "10521494814986", "10261926576394", "10261952200970"]);
  const EXCLUDED_COLLECTION_IDS = new Set(['539380711690', '236887802017']);

  const selectors = {
    mainProductForm: 'form[data-product-form]',
    addButton: '[data-add-to-cart], button[name="add"]',
    excludedTrigger: '[data-quick-add-btn], [data-add-to-cart-bar], [data-cart-bar-scroll], [data-sibling-swapper]',
    excludedContainer: 'quick-add-product, [data-quick-add-holder], [data-product-upsell-container], [data-upsell-products], [data-cart-drawer], .drawer--cart, .product__siblings',
  };

  const state = {
    modal: null,
    status: null,
    originalFormData: null,
    lastFocusedElement: null,
    addedOfferIds: new Set(),
    busy: false,
  };

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isExcludedProductContext() {
    const context = window.PEOfferPopupContext || {};
    const productId = context.productId == null ? '' : String(context.productId);
    const collectionIds = Array.isArray(context.collectionIds) ? context.collectionIds : [];

    return EXCLUDED_PRODUCT_IDS.has(productId)
      || collectionIds.some((collectionId) => EXCLUDED_COLLECTION_IDS.has(String(collectionId)));
  }

  function getAddUrl() {
    const route = window.theme?.routes?.cart_add_url || '/cart/add';
    return route.endsWith('.js') ? route : `${route}.js`;
  }

  function getCartUrl() {
    const route = window.theme?.routes?.cart_url || '/cart';
    return route.endsWith('.js') ? route : `${route.replace(/\/$/, '')}.js`;
  }

  function isDisabledButton(button) {
    return Boolean(
      button?.disabled
      || button?.getAttribute?.('aria-disabled') === 'true'
      || button?.hasAttribute?.('disabled')
    );
  }

  function isExcludedTrigger(button) {
    return Boolean(
      button?.closest?.(selectors.excludedTrigger)
      || button?.closest?.(selectors.excludedContainer)
    );
  }

  function isMainAddButton(button) {
    return Boolean(
      button?.matches?.(selectors.addButton)
      && !isDisabledButton(button)
      && !isExcludedTrigger(button)
    );
  }

  function getMainProductFormFromButton(button) {
    if (!isMainAddButton(button) || !isProductPage() || isExcludedProductContext()) {
      return null;
    }

    const form = button.closest(selectors.mainProductForm);

    if (!form || !form.contains(button) || !OFFERS.length) {
      return null;
    }

    return form;
  }

  function getOriginalFormData(form) {
    const formData = new FormData(form);

    if (!formData.get('id') && !formData.has('items[0][id]')) {
      const variantInput = form.querySelector('[name="id"]')
        || form.closest('product-form')?.querySelector('[name="id"]')
        || document.querySelector('form[data-product-form] [name="id"]');

      if (variantInput?.value) {
        formData.set('id', variantInput.value);
      }
    }

    if (!formData.get('quantity') && !formData.has('items[0][id]')) {
      formData.set('quantity', '1');
    }

    return formData;
  }

  function stopNativeAdd(event) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function formatError(error) {
    if (!error) return 'Etwas ist schiefgelaufen. Bitte versuche es erneut.';
    return error.description || error.message || String(error);
  }

  function setStatus(message, isError) {
    if (!state.status) return;
    state.status.textContent = message || '';
    state.status.classList.toggle('is-error', Boolean(isError));
    state.status.hidden = !message;
  }

  function setBusy(isBusy) {
    state.busy = isBusy;

    if (!state.modal) return;

    state.modal.querySelectorAll('button').forEach((button) => {
      if (button.hasAttribute('data-pe-offer-close')) {
        button.disabled = false;
        return;
      }

      button.disabled = isBusy || button.hasAttribute('data-pe-added');
    });
  }

  function requestCartRefresh(openCart) {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else {
      fetch(getCartUrl(), { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (!cart) return;

          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: {
              cartCount: Number(cart.item_count || 0),
            },
          }));
        })
        .catch(() => {});
    }

    if (openCart) {
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
    }
  }

  async function addToCart(body) {
    const isFormData = body instanceof FormData;
    const response = await fetch(getAddUrl(), {
      method: 'POST',
      headers: isFormData
        ? {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          }
        : {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
      body: isFormData ? body : JSON.stringify(body),
    });

    const payload = await response.json().catch(() => ({}));

    if (!response.ok || payload.status) {
      throw payload;
    }

    return payload;
  }

  function renderOfferCards() {
    return OFFERS.map((offer, index) => {
      const compareAtPrice = offer.compareAtPrice
        ? `<span class="pe-offer-popup__compare">${offer.compareAtPrice}</span>`
        : '';

      return `
        <article class="pe-offer-popup__card" data-pe-offer-card="${offer.id}">
          <div class="pe-offer-popup__image-wrap">
            <img class="pe-offer-popup__image" src="${offer.image}" alt="${offer.imageAlt}" loading="eager">
          </div>
          <h3 class="pe-offer-popup__product-title">${offer.title}</h3>
          <p class="pe-offer-popup__price">
            ${compareAtPrice}
            <span class="pe-offer-popup__sale">${offer.price}</span>
          </p>
          <button class="pe-offer-popup__add" type="button" data-pe-offer-add="${index}">
            Hinzufügen
          </button>
        </article>
      `;
    }).join('');
  }

  function ensureModal() {
    if (state.modal) return state.modal;

    const wrapper = document.createElement('div');
    wrapper.className = 'pe-offer-popup';
    wrapper.hidden = true;
    wrapper.innerHTML = `
      <div class="pe-offer-popup__overlay" data-pe-offer-dismiss></div>
      <section class="pe-offer-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="pe-offer-popup-title">
        <header class="pe-offer-popup__header">
          <h2 class="pe-offer-popup__title" id="pe-offer-popup-title">Warte, vergiss diese nicht …</h2>
          <button class="pe-offer-popup__close" type="button" aria-label="Weiter mit meinem Kauf" data-pe-offer-close>
            <span aria-hidden="true">×</span>
          </button>
        </header>
        <div class="pe-offer-popup__body">
          <div class="pe-offer-popup__grid">
            ${renderOfferCards()}
          </div>
        </div>
        <div class="pe-offer-popup__footer">
          <p class="pe-offer-popup__status" data-pe-offer-status hidden></p>
          <button class="pe-offer-popup__continue" type="button" data-pe-offer-continue>
            Weiter mit meinem Kauf
          </button>
        </div>
      </section>
    `;

    document.body.appendChild(wrapper);
    state.modal = wrapper;
    state.status = wrapper.querySelector('[data-pe-offer-status]');

    wrapper.addEventListener('click', handleModalClick);
    document.addEventListener('keydown', handleKeydown);

    return wrapper;
  }

  function updateOfferState(offerId) {
    const card = state.modal?.querySelector(`[data-pe-offer-card="${offerId}"]`);
    const button = card?.querySelector('[data-pe-offer-add]');

    if (!card || !button) return;

    card.classList.add('is-added');
    button.textContent = 'Hinzugefügt';
    button.setAttribute('data-pe-added', 'true');
    button.disabled = true;
  }

  function openPopup(form) {
    const modal = ensureModal();

    state.originalFormData = getOriginalFormData(form);
    state.lastFocusedElement = document.activeElement;
    state.addedOfferIds = new Set();
    setBusy(false);

    modal.querySelectorAll('.pe-offer-popup__card').forEach((card) => card.classList.remove('is-added'));
    modal.querySelectorAll('[data-pe-offer-add]').forEach((button) => {
      button.textContent = 'Hinzufügen';
      button.removeAttribute('data-pe-added');
      button.disabled = false;
    });

    setStatus('', false);
    modal.hidden = false;
    document.documentElement.classList.add('pe-offer-popup-open');

    modal.classList.add('is-visible');
    modal.querySelector('[data-pe-offer-add]')?.focus({preventScroll:true});
  }

  function closePopup() {
    if (!state.modal || state.busy) return;
    state.modal.classList.remove('is-visible');
    state.modal.hidden = true;
    state.originalFormData = null;
    document.documentElement.classList.remove('pe-offer-popup-open');
    if (state.lastFocusedElement?.isConnected) state.lastFocusedElement.focus({preventScroll:true});
  }

  function isPopupOpen() {
    return Boolean(state.modal && !state.modal.hidden);
  }

  async function completeOriginalPurchase() {
    if (!state.originalFormData || state.busy) return;

    setBusy(true);
    setStatus('Dein Produkt wird hinzugefügt...', false);

    try {
      await addToCart(state.originalFormData);
      setBusy(false);
      closePopup();
      requestCartRefresh(true);
    } catch (error) {
      setStatus(formatError(error), true);
      setBusy(false);
    }
  }

  async function addOffer(index) {
    const offer = OFFERS[index];

    if (!offer || state.busy || state.addedOfferIds.has(offer.id)) return;

    setBusy(true);
    setStatus('Angebot wird hinzugefügt...', false);

    try {
      await addToCart({
        items: [
          {
            id: Number(offer.id),
            quantity: 1,
          },
        ],
      });

      state.addedOfferIds.add(offer.id);
      updateOfferState(offer.id);

      if (state.addedOfferIds.size >= OFFERS.length) {
        setStatus('Angebote hinzugefügt. Dein Produkt wird hinzugefügt...', false);
        setBusy(false);
        await completeOriginalPurchase();
        return;
      }

      setStatus('Hinzugefügt. Du kannst noch etwas hinzufügen oder fortfahren.', false);
      setBusy(false);
    } catch (error) {
      setStatus(formatError(error), true);
      setBusy(false);
    }
  }

  function handleModalClick(event) {
    const closeButton = event.target.closest('[data-pe-offer-close]');
    const dismissButton = event.target.closest('[data-pe-offer-dismiss]');
    const continueButton = event.target.closest('[data-pe-offer-continue]');
    const offerButton = event.target.closest('[data-pe-offer-add]');

    if (closeButton) {
      if (state.busy) return;
      completeOriginalPurchase();
      return;
    }

    if (dismissButton) {
      closePopup();
      return;
    }

    if (continueButton) {
      completeOriginalPurchase();
      return;
    }

    if (offerButton) {
      addOffer(Number(offerButton.getAttribute('data-pe-offer-add')));
    }
  }

  function handleKeydown(event) {
    if (!state.modal || state.modal.hidden) return;

    if (event.key === 'Escape') {
      closePopup();
    }
  }

  function handleSubmit(event) {
    const form = event.target?.matches?.(selectors.mainProductForm) ? event.target : null;
    const submitter = event.submitter || form?.querySelector('button[type="submit"][data-add-to-cart], button[name="add"]');

    if (!form || !submitter || getMainProductFormFromButton(submitter) !== form) return;

    if (isPopupOpen()) {
      stopNativeAdd(event);
      return;
    }

    if (state.busy) { stopNativeAdd(event); return; }
    if (form.classList.contains('uploadkit-invalid') || !form.checkValidity()) return;

    stopNativeAdd(event);
    openPopup(form);
  }

  function handleClick(event) {
    const button = event.target?.closest?.(selectors.addButton);

    if (!button) return;

    const form = getMainProductFormFromButton(button);

    if (!form) return;

    if (isPopupOpen()) {
      stopNativeAdd(event);
      return;
    }

    if (state.busy) { stopNativeAdd(event); return; }
    if (form.classList.contains('uploadkit-invalid') || !form.checkValidity()) return;

    stopNativeAdd(event);
    openPopup(form);
  }

  function injectStyles() {
    if (document.getElementById('pe-offer-popup-styles')) return;

    const style = document.createElement('style');
    style.id = 'pe-offer-popup-styles';
    style.textContent = `
      .pe-offer-popup-open { overflow: hidden; }
      .pe-offer-popup[hidden] { display: none; }
      .pe-offer-popup {
        position: fixed;
        inset: 0;
        z-index: 100200;
        display: grid;
        place-items: center;
        padding: 18px;
        opacity: 0;
        transition: opacity 180ms ease;
      }
      .pe-offer-popup.is-visible { opacity: 1; }
      .pe-offer-popup__overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.58);
        backdrop-filter: blur(3px);
      }
      .pe-offer-popup__dialog {
        position: relative;
        width: min(760px, 100%);
        max-height: min(92vh, 760px);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 18px 55px rgba(0, 0, 0, 0.28);
        transform: translateY(8px) scale(0.98);
        transition: transform 180ms ease;
      }
      .pe-offer-popup.is-visible .pe-offer-popup__dialog {
        transform: translateY(0) scale(1);
      }
      .pe-offer-popup__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 18px 16px 16px;
        border-bottom: 1px solid #d5e4dc;
      }
      .pe-offer-popup__title {
        margin: 0;
        color: #20574e;
        font-family: inherit;
        font-size: 22px;
        font-weight: 800;
        line-height: 1.2;
      }
      .pe-offer-popup__close {
        width: 34px;
        height: 34px;
        display: grid;
        place-items: center;
        flex: 0 0 auto;
        border: 0;
        background: transparent;
        color: #45675e;
        cursor: pointer;
        font-size: 34px;
        line-height: 1;
      }
      .pe-offer-popup__body {
        padding: 16px;
        overflow-y: auto;
      }
      .pe-offer-popup__grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 14px;
      }
      .pe-offer-popup__card {
        min-width: 0;
        text-align: center;
      }
      .pe-offer-popup__image-wrap {
        aspect-ratio: 1 / 1;
        overflow: hidden;
        border: 1px solid #d5e4dc;
        border-radius: 14px;
        background: #f4f8f6;
      }
      .pe-offer-popup__image {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
      .pe-offer-popup__product-title {
        min-height: 42px;
        margin: 8px 0 4px;
        color: #20574e;
        font-family: inherit;
        font-size: 16px;
        font-weight: 800;
        line-height: 1.25;
      }
      .pe-offer-popup__price {
        min-height: 24px;
        margin: 0 0 10px;
        font-size: 15px;
        line-height: 1.4;
      }
      .pe-offer-popup__compare {
        margin-right: 4px;
        color: #677970;
        text-decoration: line-through;
      }
      .pe-offer-popup__sale {
        color: #20574e;
      }
      .pe-offer-popup__add,
      .pe-offer-popup__continue {
        min-height: 40px;
        width: 100%;
        border: 1px solid #20574e;
        border-radius: 6px;
        background: #20574e;
        color: #ffffff;
        cursor: pointer;
        font: inherit;
        font-size: 15px;
        font-weight: 800;
        line-height: 1.2;
        text-transform: uppercase;
        transition: background 150ms ease, color 150ms ease, opacity 150ms ease;
      }
      .pe-offer-popup__add:hover,
      .pe-offer-popup__continue:hover {
        background: #173e38;
      }
      .pe-offer-popup__add:disabled,
      .pe-offer-popup__continue:disabled {
        cursor: wait;
        opacity: 0.72;
      }
      .pe-offer-popup__card.is-added .pe-offer-popup__add {
        border-color: #268458;
        background: #268458;
        cursor: default;
      }
      .pe-offer-popup__status {
        margin: 14px 0 0;
        color: #456057;
        font-size: 14px;
        line-height: 1.35;
        text-align: center;
      }
      .pe-offer-popup__status.is-error {
        color: #b42318;
      }
      .pe-offer-popup__continue {
        margin-top: 14px;
        background: #ffffff;
        color: #20574e;
      }
      .pe-offer-popup__continue:hover {
        background: #edf5f0;
      }
      @media (max-width: 520px) {
        .pe-offer-popup {
          place-items: center;
          padding: 10px;
        }
        .pe-offer-popup__dialog {
          width: 100%;
          max-height: 88vh;
        }
        .pe-offer-popup__header {
          padding: 15px 14px 13px;
        }
        .pe-offer-popup__title {
          font-size: 19px;
        }
        .pe-offer-popup__body {
          padding: 12px;
        }
        .pe-offer-popup__grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 10px;
        }
        .pe-offer-popup__product-title {
          min-height: 38px;
          font-size: 14px;
        }
        .pe-offer-popup__price {
          font-size: 13px;
        }
        .pe-offer-popup__add,
        .pe-offer-popup__continue {
          min-height: 38px;
          font-size: 13px;
        }
      }

      .pe-offer-popup__card {display:flex;flex-direction:column;align-items:stretch;}
      .pe-offer-popup__image-wrap {flex:none;}
      .pe-offer-popup__product-title {flex:1;margin:12px 0 10px;font-weight:700;}
      .pe-offer-popup__price {display:flex;flex-wrap:wrap;align-items:baseline;justify-content:center;gap:6px;flex:none;margin:0 0 14px;}
      .pe-offer-popup__compare {margin:0;}
      .pe-offer-popup__sale {font-weight:700;}
      .pe-offer-popup__add {flex:none;min-height:44px;}
      .pe-offer-popup__continue {min-height:44px;}
      .pe-offer-popup__add:focus-visible,.pe-offer-popup__continue:focus-visible,.pe-offer-popup__close:focus-visible {outline:3px solid #308980;outline-offset:3px;}

      /* Three offers stay on one row; the purchase action never scrolls away. */
      .pe-offer-popup {padding:12px;}
      .pe-offer-popup__dialog {max-height:calc(100vh - 24px);max-height:calc(100dvh - 24px);}
      .pe-offer-popup__header {flex:none;}
      .pe-offer-popup__body {flex:1 1 auto;min-height:0;overscroll-behavior:contain;}
      .pe-offer-popup__footer {flex:none;padding:12px 16px max(12px,env(safe-area-inset-bottom));border-top:1px solid #d5e4dc;background:#fff;}
      .pe-offer-popup__footer .pe-offer-popup__continue {margin:0;min-height:44px;}
      .pe-offer-popup__footer .pe-offer-popup__status {margin:0 0 10px;max-height:4em;overflow:auto;}
      .pe-offer-popup__grid {grid-template-columns:repeat(3,minmax(0,1fr));}
      .pe-offer-popup__grid:has(> :last-child:nth-child(2)) {grid-template-columns:repeat(2,minmax(0,1fr));}
      @media(max-width:520px){
        .pe-offer-popup {padding:10px;}
        .pe-offer-popup__dialog {max-height:calc(100vh - 20px);max-height:calc(100dvh - 20px);}
        .pe-offer-popup__header {padding:12px;gap:8px;}
        .pe-offer-popup__title {font-size:18px;}
        .pe-offer-popup__body {padding:12px 10px;}
        .pe-offer-popup__grid {gap:8px;}
        .pe-offer-popup__image-wrap {border-radius:8px;}
        .pe-offer-popup__product-title {font-size:12px;line-height:1.3;margin:8px 0;min-height:0;overflow-wrap:anywhere;}
        .pe-offer-popup__price {font-size:12px;line-height:1.3;gap:3px;margin-bottom:8px;}
        .pe-offer-popup__compare {font-size:10px;}
        .pe-offer-popup__add {font-size:10px;letter-spacing:0;padding:7px 2px;min-height:44px;}
        .pe-offer-popup__footer {padding:10px 12px max(10px,env(safe-area-inset-bottom));}
        .pe-offer-popup__footer .pe-offer-popup__continue {font-size:12px;padding:10px;}
      }
      @media(max-height:500px){.pe-offer-popup__header{padding-block:8px}.pe-offer-popup__image-wrap{max-height:120px;aspect-ratio:auto}.pe-offer-popup__image{height:120px;object-fit:contain}.pe-offer-popup__body{padding-block:10px}}
    `;

    document.head.appendChild(style);
  }

  function init() {
    if (!isProductPage() || isExcludedProductContext()) return;

    injectStyles();
    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', handleSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
